<template>

    <div class="container">
        
        <app-head title="Dashboard" />
        
        <h1>{{ __('Dashboard') }}</h1>
        <hr />
        <div class="row row-cols-1 row-cols-md-3 g-4">
            <div class="col">
                <div class="card">
                    <div class="card-body">
                        <h5 class="card-title">{{ __('Bestellungen heute') }}</h5>
                        <p class="card-text fs-1">{{ analyticsData.number_of_orders }}</p>
                        <inertia-link :href="route('admin.orders.index')" class="btn btn-outline-primary">
                            {{ __('Bestellungen ansehen') }}
                        </inertia-link>
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="card">
                    <div class="card-body">
                        <h5 class="card-title">{{ __('Nettoumsatz heute') }}</h5>
                        <p class="card-text fs-1">{{ analyticsData.total_revenue | localizeAmount }}</p>
                        <inertia-link :href="route('admin.analytics.index')" class="btn btn-outline-primary">
                            {{ __('Auswertung ansehen') }}
                        </inertia-link>
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="card">
                    <div class="card-body">
                        <h5 class="card-title">{{ __('Bruttoumsatz heute') }}</h5>
                        <p class="card-text fs-1">{{ analyticsData.total_gross_revenue | localizeAmount }}</p>
                        <inertia-link :href="route('admin.analytics.index')" class="btn btn-outline-primary">
                            {{ __('Auswertung ansehen') }}
                        </inertia-link>
                    </div>
                </div>
            </div>
        </div>
<!--        <hr />@todo
        <div class="row row-cols-1 row-cols-md-2 g-4">
            <div class="col">
                <chart-box title="Umsatz gesamt" />
            </div>
            <div class="col">
                <chart-box title="Nettoumsatz" />
            </div>
        </div>-->
        <!--        <hr />
                <div class="row row-cols-1 row-cols-md-3 g-4">
                    <div class="col">
                        <chart-box title="Bestellungen heute" />
                    </div>
                    <div class="col">
                        <chart-box title="Bestellungen gesamt" />
                    </div>
                    <div class="col">
                        <chart-box title="Bestellungen gesamt" />
                    </div>
                </div>-->
    </div>

</template>

<script>
    import ChartBox from '@/shared/Admin/ChartBox';

    export default {
        props: [
            'analyticsData'
        ],
        components: {
            ChartBox,
        }
    }
</script>